import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios"; // Using axios for API requests

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [load, setLoad] = useState(false);

  const BASE_URL = process.env.REACT_APP_OTHER_API_URL; // Replace with your API base URL
  const authToken = process.env.REACT_APP_authToken; // Optional auth-token if needed
  const headers = { "auth-token": authToken };

  // Validate email
  const validate = () => {
    const newErrors = {};
    if (!email) newErrors.email = "Email is required.";
    else if (!/^\S+@\S+\.\S+$/.test(email))
      newErrors.email = "Enter a valid email address.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoad(true);

    try {
      const payload = { email }; // API payload
      const response = await axios.post(`${BASE_URL}/forgot_password`, payload, { headers });

      if (response.data?.status) {
        toast.success(response.data.message || "Reset instructions sent!");
        setTimeout(() => navigate("/check-email"), 2000);
      } else {
        setTimeout(() => navigate("/check-email"), 2000);
        toast.error(response.data.message || "Something went wrong.");
      }
    } catch (error) {
      toast.error("Server error. Please try again later.");
       setTimeout(() => navigate("/check-email"), 2000);
      console.error(error);
    } finally {
      setLoad(false);
    }
  };

  return (
    <div className="wrapper">
      <section className="signin-page forgot_password">
        <Container fluid className="p-0">
          <div className="signin_inner">
            <Row className="align-items-center gx-0">
              {/* LEFT IMAGE */}
              <Col md={12} lg={6}>
                <div className="signin-left">
                  <img
                    src="/images/login_bg.png"
                    className="img-fluid login_bg"
                    alt="login_bg"
                  />
                </div>
              </Col>

              {/* RIGHT FORM */}
              <Col md={12} lg={6}>
                <div className="signin-right w-100 p-4">

                  {/* Logo, key icon, and title */}
                  <div className="logo mb-4">
                    <img src="/images/logo.png" className="img-fluid mb-4" alt="logo" />

                    <span className="key_icon mb-4 d-block">
                      {/* Inline SVG for key icon */}
                      <svg
                        width="11"
                        height="22"
                        viewBox="0 0 11 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.88475 5.5C3.88475 5.0525 4.04208 4.67142 4.35675 4.35675C4.67142 4.04208 5.0525 3.88475 5.5 3.88475C5.9475 3.88475 6.32858 4.04208 6.64325 4.35675C6.95792 4.67142 7.11525 5.0525 7.11525 5.5C7.11525 5.9475 6.95792 6.32858 6.64325 6.64325C6.32858 6.95792 5.9475 7.11525 5.5 7.11525C5.0525 7.11525 4.67142 6.95792 4.35675 6.64325C4.04208 6.32858 3.88475 5.9475 3.88475 5.5ZM5.5 21.8943L1.67325 18.048L3.06725 16.1923L1.654 14.2885L3 12.3365V10.3923C2.11283 9.93592 1.39108 9.27442 0.83475 8.40775C0.27825 7.54108 0 6.57183 0 5.5C0 3.97433 0.53525 2.67625 1.60575 1.60575C2.67625 0.535249 3.97433 0 5.5 0C7.02567 0 8.32375 0.535249 9.39425 1.60575C10.4648 2.67625 11 3.97433 11 5.5C11 6.57183 10.7234 7.54108 10.1702 8.40775C9.61692 9.27442 8.8935 9.93592 8 10.3923V19.3943L5.5 21.8943ZM1.5 5.5C1.5 6.459 1.78975 7.28942 2.36925 7.99125C2.94875 8.69325 3.659 9.15133 4.5 9.3655V12.8077L3.50375 14.248L4.93275 16.202L3.6345 17.9L5.5 19.7655L6.5 18.7655V9.3655C7.341 9.15133 8.05125 8.69325 8.63075 7.99125C9.21025 7.28942 9.5 6.459 9.5 5.5C9.5 4.4 9.10833 3.45833 8.325 2.675C7.54167 1.89167 6.6 1.5 5.5 1.5C4.4 1.5 3.45833 1.89167 2.675 2.675C1.89167 3.45833 1.5 4.4 1.5 5.5Z"
                          fill="#2491BB"
                        />
                      </svg>
                    </span>

                    <h2 className="font_24 clr_blue font-600 mb-2">Forgot password?</h2>
                    <p className="clr_grey font_14 font-400">
                      No worries, we’ll send you reset instructions.
                    </p>
                  </div>

                  {/* Form */}
                  <Form onSubmit={handleSubmit} noValidate>
                    <Form.Group className="form-floating mb-4">
                      <Form.Control
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        isInvalid={!!errors.email}
                      />
                      <Form.Label>Email *</Form.Label>
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Button
                      type="submit"
                      className="btn sky_theme w-100 py-2"
                      disabled={load}
                    >
                      {load ? "Processing..." : "Reset Password"}
                    </Button>

                    <Link
                      to="/login"
                      className="btn p-0 clr_sky w-100 font_14 font-500 mt-3 back_login d-flex align-items-center justify-content-start"
                    >
                      <i className="fa-solid fa-arrow-left me-2"></i> Back to Log In
                    </Link>
                  </Form>

                </div>
              </Col>

            </Row>
          </div>
        </Container>
      </section>

      <ToastContainer />
    </div>
  );
};

export default ForgotPassword;
